// eslint-disable-next-line no-unused-vars
import Widget from "rasa-webchat";
import mask from "./utils/phoneMask";
import "./App.css";
import { RASA_CORE_URL } from "./config";

function CustomWidget() {

  return (
    <Widget
      initPayload={"/cumprimentar"}
      socketUrl={RASA_CORE_URL}
      customData={{ language: "pt-br" }}
      title={"PicPay"}
      subtitle={"Assistente Virtual"}
      inputTextFieldHint={"Digite sua mensagem..."}
      showCloseButton={false}
      showFullScreenButton={false}
      fullScreenMode={true}
      onSocketEvent={{
        bot_uttered: (event) => {
          mask(event);
        },
      }}
      params={{ storage: "session" }}
    />
  );
}

export default CustomWidget;
